const effectInfo = {
  squadLeader: {
    armor: 1
  }
};
export default effectInfo;
